import './BilingualTranslate.less';
import Icon from '@/components/iconfont/Icon';
import { useState, useContext, useEffect, useCallback } from 'react';
import { EditContext } from '@/context/EditContext';
import { formatMilliseconds } from '@/utils/dayjs';
import { projectController } from '@/api/edit';
import {
  modifySubtitle,
  deleteMaterial,
  addSubtitleSegmented,
  reTranslationSubtitle,
} from '@/components/Timeline/command.ts';
import { useTranslation } from 'react-i18next';
import AddsubtitleEmptySvg from '@/assets/edit/addsubtitleempty.svg';
import TransliateSubtitleIcon from '@/assets/edit/transliateSubtitleIcon.svg';
import AddIcon from '@/assets/edit/addIcon.svg';
import { useWebSocket } from '@/hooks/useWebSocket.js';
import { MessageEventType } from '@/utils/socket.js';
import message from '@/utils/message';
import EditPopUp from '../../popup/Popup';
export default function BilingualTranslate({ handleTranslateAll, handleUpdateAll }) {
  const { t } = useTranslation();
  const {
    sessionId,
    // setTimelinePlaybackTime,
    timelinePlaybackTime,
    // subtitlePlayItem,
    setSubtitlePlayItem,
    setTranslationMaterial,
    setSentenceMaterial,
    sentenceMaterial,
    translationMaterial,
    useTranslate,
    translationLanguage,
    setActiveTab,
    setIsInputFocused,
    mode,
    projectDetail,
    languagesArray,
    clickOutsideListener,
    setSubtitleBilingualPlayItem,
    setSentenceTranslationPopup,
  } = useContext(EditContext);
  const [clickSubtitleOriginalItem, setClickSubtitleOriginalItem] = useState({});
  const [clickSubtitleBilingualItem, setClickSubtitleBilingualItem] = useState({});
  const [clickEventLock, setClickEventLock] = useState(false);
  // const [textLengths, setTextLengths] = useState({});
  // const [clickSubtitleItem, setClickSubtitleItem] = useState({});
  // const [clickSubtitleSegmentedItem, setClickSubtitleSegmentedItem] = useState({});

  const [sentences, setSentences] = useState([]);

  useWebSocket(
    MessageEventType.TRANSLATION_MESSAGE,
    useCallback(
      async ({ isSucceed, detail, projectId }) => {
        if (!isSucceed) {
          message.error('翻译失败', { id: 'translate' });
        }

        const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
        if (projectItem.id === projectId) {
          const index = translationMaterial.details.findIndex(
            (item) => Number(item.id) === Number(detail.id),
          );
          if (index !== -1) {
            translationMaterial.details[index] = JSON.parse(JSON.stringify(detail));
            sentenceMaterial.details[index].subtitleEdit = detail.subtitleEdit;
          }
          setSentenceMaterial({ ...sentenceMaterial });
          setTranslationMaterial({ ...translationMaterial });
          setTimeout(() => {
            // updateMaterial(detail);
            if (mode === 'translation_and_tts') {
              reTranslationSubtitle(translationMaterial.details[index], 1);
            } else {
              reTranslationSubtitle(sentenceMaterial.details[index], 0);
            }
          }, 10);
        }
      },
      [translationMaterial, sentenceMaterial, mode],
    ),
  );
  useEffect(() => {
    if (JSON.stringify(sentenceMaterial) === '{}') return;
    let combinedSentences;
    if (mode === 'translation_and_tts') {
      console.log(translationMaterial, sentenceMaterial, 'sente123ncesentence');
      combinedSentences = translationMaterial.details?.map((translation) => {
        const sentence = sentenceMaterial.details.find(
          (item) => Number(item.id) === Number(translation.id),
        );
        console.log(sentence, translation, 'sente123ncesentence translationtranslation');

        if (Number(sentence?.subtitle?.id) >= 0) {
          return {
            id: Number(translation?.subtitle?.id),
            originalId: sentence?.id,
            translationId: translation?.id,
            timeLineFrom: translation?.subtitle.timeLineFrom,
            timeLineTo: translation?.subtitle.timeLineTo,
            original: sentence?.subtitle.text,
            translation: translation?.subtitle?.text,
            originalSegmented: sentence?.subtitleSegmented,
            translationSegmented: translation?.subtitleSegmented,
            translating: translation?.translating,
            subtitleEdit: sentence?.subtitleEdit,
          };
        }
      });
    } else {
      combinedSentences = sentenceMaterial.details?.map((sentence) => {
        const translation = translationMaterial.details.find(
          (item) => Number(item.id) === Number(sentence.id),
        );

        if (Number(sentence?.subtitle?.id) >= 0) {
          return {
            id: Number(translation?.subtitle?.id),
            originalId: sentence?.id,
            translationId: translation?.id,
            timeLineFrom: sentence?.subtitle.timeLineFrom,
            timeLineTo: sentence?.subtitle.timeLineTo,
            original: sentence?.subtitle.text,
            translation: translation?.subtitle?.text,
            originalSegmented: sentence?.subtitleSegmented,
            translationSegmented: translation?.subtitleSegmented,
            translating: translation?.translating,
            subtitleEdit: sentence?.subtitleEdit,
          };
        }
      });
    }

    const filteredSentences = combinedSentences.filter((item) => item !== undefined);
    console.log(filteredSentences, 'filteredSentences');

    setSentences(filteredSentences);
    setTimeout(() => {
      setClickEventLock(true);
    }, 10);
    // const initialLengths = {};
    // filteredSentences.forEach((item) => {
    //   initialLengths['o' + item.id] = item.original?.length || 0;
    // });
    // filteredSentences.forEach((item) => {
    //   initialLengths['t' + item.id] = item.translation?.length || 0;
    // });

    // setTextLengths((prev) => ({
    //   ...prev,
    //   ...initialLengths,
    // }));
  }, [sentenceMaterial, translationMaterial, mode]);

  useEffect(() => {
    if (useTranslate) {
      const currentSentence = sentences.find(
        (item) =>
          item.timeLineFrom <= timelinePlaybackTime && item.timeLineTo > timelinePlaybackTime,
      );
      if (currentSentence) {
        if (mode === 'translation' || mode === 'add_subtitle_and_translation') {
          const index = currentSentence.originalSegmented.findIndex(
            (item) =>
              item.timeLineFrom <= timelinePlaybackTime && item.timeLineTo > timelinePlaybackTime,
          );
          setSubtitlePlayItem(currentSentence.originalSegmented[index]);
          setSubtitleBilingualPlayItem(currentSentence.translationSegmented[index]);
        } else {
          const currentSentenceSegmented = currentSentence.originalSegmented.find(
            (item) =>
              item.timeLineFrom <= timelinePlaybackTime && item.timeLineTo > timelinePlaybackTime,
          );

          setSubtitlePlayItem(currentSentenceSegmented);
          const currentBilingualSegmented = currentSentence.translationSegmented.find(
            (item) =>
              item.timeLineFrom <= timelinePlaybackTime && item.timeLineTo > timelinePlaybackTime,
          );

          setSubtitleBilingualPlayItem(currentBilingualSegmented);
        }
      } else {
        setSubtitlePlayItem({});
        setSubtitleBilingualPlayItem({});
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timelinePlaybackTime, sentences, useTranslate, mode]);

  useEffect(() => {
    if (clickOutsideListener && clickEventLock) {
      //  关闭所有的句子更多操作的下拉框;
      if (
        !clickOutsideListener.target.closest('.more_box_option') &&
        !clickOutsideListener.target.closest('.more_operations')
      ) {
        sentences.forEach((sentence) => {
          sentence.originalSegmented.filter((segmented) => {
            segmented.moreShow = false;
          });
          sentence.translationSegmented.filter((segmented) => {
            segmented.moreShow = false;
          });
        });
        setSentences([...sentences]);
      }
      if (
        !clickOutsideListener.target.closest('.sentence_segmented_item') &&
        !clickOutsideListener.target.closest('.sentence_item_text')
      ) {
        // setClickSubtitleItem({});
        // setClickSubtitleSegmentedItem({});
      }
    }
  }, [clickOutsideListener, clickEventLock]);

  useEffect(() => {
    handleTranslateAll(translateSubtitle);
  }, []);

  // 点击某个句子
  const handleSentenceItem = (sentencesItem, item) => {
    console.log(item);
    // setClickSubtitleItem(sentencesItem);
    // setClickSubtitleSegmentedItem(item);
    // setTimelinePlaybackTime(item.timeLineFrom);
  };
  //   点击某个句子上的更多操作
  const handleMoreClick = (sentencesItem, sentencesIndex, item, index) => {
    // 先将所有moreShow置为false，再修改对应点击项的moreShow为true
    console.log(sentencesItem, sentencesIndex, item, index);

    // 将所有句子的moreShow属性设置为false
    sentences.forEach((sentence) => {
      sentence.originalSegmented.forEach((segmented, segmentedIndex) => {
        if (segmentedIndex !== index) {
          segmented.moreShow = false;
        }
      });
    });
    // 切换当前点击项的moreShow属性
    sentences[sentencesIndex].originalSegmented[index].moreShow = !item.moreShow;
    // setClickSubtitleSegmentedItem(item);
    setSentences([...sentences]); // 更新状态以触发重新渲染
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // 阻止默认的换行行为
      e.target.blur(); // 使元素失焦
      setClickSubtitleBilingualItem({});
      setClickSubtitleOriginalItem({});
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();

    // 获取纯文本，避免粘贴格式
    const pastedText = e.clipboardData.getData('text/plain');

    // 获取当前选择范围
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);

    // 插入文本
    const textNode = document.createTextNode(pastedText);
    range.deleteContents();
    range.insertNode(textNode);

    // 将光标移动到插入文本的末尾
    range.setStartAfter(textNode);
    range.setEndAfter(textNode);
    selection.removeAllRanges();
    selection.addRange(range);
  };

  // ------------------原文方法------------------------------------
  const handleClickSentenceOriginalItem = (item) => {
    setClickSubtitleOriginalItem(item);
  };
  const handleOriginalInput = (sentencesItem) => {
    console.log(sentencesItem, sentences);
    sentencesItem.subtitleEdit = true;
    setSentences([...sentences]);
    // const targetIndex = sentenceMaterial.details.findIndex(
    //   (detail) => Number(detail.id) === Number(sentencesItem.id),
    // );
    // sentenceMaterial.details[targetIndex].subtitleEdit = true;
    // setSentenceMaterial({ ...sentenceMaterial });
  };

  const handleOriginalInputBlur = (e) => {
    const content = e.target.textContent;
    const value = content.slice(0, 1000); // 限制长度

    return value;
  };
  const editOriginalSentence = async (sentencesItem, item, index, value) => {
    const targetIndex = sentenceMaterial.details.findIndex(
      (detail) => Number(detail.id) === Number(sentencesItem.id),
    );
    if (targetIndex === -1) return;
    if (value !== item.text) {
      sentenceMaterial.details[targetIndex].subtitleEdit = true;
    }
    sentenceMaterial.details[targetIndex].subtitleSegmented[index].text = value;
    console.log(sentenceMaterial.details[targetIndex].subtitleSegmented);
    const segmentedText = sentenceMaterial.details[targetIndex].subtitleSegmented.map(
      (segmented) => segmented.text,
    );
    const combinedText = languagesArray.includes(projectDetail.language)
      ? segmentedText.join('')
      : segmentedText.join(' ');
    sentenceMaterial.details[targetIndex].subtitle.text = combinedText;

    setSentenceMaterial({ ...sentenceMaterial });
    setClickSubtitleOriginalItem({});
    modifySubtitle(1, item.id, value);
    const obj = {
      id: sentenceMaterial.details[targetIndex].id,
      type: sentenceMaterial.details[targetIndex].type,
      subtitle: sentenceMaterial.details[targetIndex].subtitle,
      subtitleSegmented: sentenceMaterial.details[targetIndex].subtitleSegmented,
      subtitleEdit: true,
    };
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      projectController.timelineOp({
        projectId: projectItem.id,
        body: {
          sessionId,
          isTranslation: false,
          isTranslationText: false,
          timelineOpTypeEnum: 12,
          materialDetail: obj,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  // ------------------原文方法------------------------------------

  // ------------------译文方法------------------------------------
  const handleClickSentenceBilingualItem = (item) => {
    setClickSubtitleBilingualItem(item);
  };

  const handleBilingualInputBlur = (e) => {
    const content = e.target.textContent;
    const value = content.slice(0, 1000); // 限制长度
    return value;
  };
  const editBilingualSentence = async (sentencesItem, item, index, value) => {
    const targetIndex = translationMaterial.details.findIndex(
      (detail) => Number(detail.id) === Number(sentencesItem.id),
    );
    if (targetIndex === -1) return;
    translationMaterial.details[targetIndex].subtitleSegmented[index].text = value;
    console.log(translationMaterial.details[targetIndex].subtitleSegmented);
    const segmentedText = translationMaterial.details[targetIndex].subtitleSegmented.map(
      (segmented) => segmented.text,
    );
    const combinedText = languagesArray.includes(translationLanguage)
      ? segmentedText.join('')
      : segmentedText.join(' ');
    translationMaterial.details[targetIndex].subtitle.text = combinedText;
    setTranslationMaterial({ ...translationMaterial });
    setClickSubtitleBilingualItem({});
    modifySubtitle(4, item.id, value);
    const obj = {
      id: translationMaterial.details[targetIndex].id,
      type: translationMaterial.details[targetIndex].type,
      subtitle: translationMaterial.details[targetIndex].subtitle,
      subtitleSegmented: translationMaterial.details[targetIndex].subtitleSegmented,
    };
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      projectController.timelineOp({
        projectId: projectItem.id,
        body: {
          sessionId,
          isTranslation: true,
          isTranslationText: true,
          timelineOpTypeEnum: 12,
          language: translationLanguage,
          materialDetail: obj,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };
  // ------------------译文方法------------------------------------

  const handleDeleteSubtitle = (sentencesItem, item, index) => {
    // 原文
    //     originalId
    // translationId
    const targetIndex = sentenceMaterial.details.findIndex(
      (detail) => Number(detail.id) === Number(sentencesItem.originalId),
    );
    if (targetIndex === -1) return;
    console.log(sentenceMaterial.details[targetIndex], index, '23123');

    sentenceMaterial.details[targetIndex].subtitleSegmented[index].text = '';
    // ;
    console.log(sentenceMaterial.details[targetIndex].subtitleSegmented);
    const segmentedText = sentenceMaterial.details[targetIndex].subtitleSegmented.map(
      (segmented) => segmented.text,
    );
    const combinedText = languagesArray.includes(projectDetail.language)
      ? segmentedText.join('')
      : segmentedText.join(' ');
    sentenceMaterial.details[targetIndex].subtitle.text = combinedText;
    setSentenceMaterial({ ...sentenceMaterial });
    modifySubtitle(1, item.id, '');
    const obj = {
      id: sentenceMaterial.details[targetIndex].id,
      type: sentenceMaterial.details[targetIndex].type,
      subtitle: sentenceMaterial.details[targetIndex].subtitle,
      subtitleSegmented: sentenceMaterial.details[targetIndex].subtitleSegmented,
    };

    // 原文

    // 译文
    const translationIndex = translationMaterial.details.findIndex(
      (detail) => Number(detail.id) === Number(sentencesItem.translationId),
    );
    if (translationIndex === -1) return;
    translationMaterial.details[translationIndex].subtitleSegmented[index].text = '';
    console.log(translationMaterial.details[translationIndex].subtitleSegmented);
    const segmentedTranslationText = translationMaterial.details[
      translationIndex
    ].subtitleSegmented.map((segmented) => segmented.text);
    const combinedTranslationText = languagesArray.includes(translationLanguage)
      ? segmentedTranslationText.join('')
      : segmentedTranslationText.join(' ');
    translationMaterial.details[translationIndex].subtitle.text = combinedTranslationText;
    setTranslationMaterial({ ...translationMaterial });
    modifySubtitle(4, item.id, '');
    const translationObj = {
      id: translationMaterial.details[translationIndex].id,
      type: translationMaterial.details[translationIndex].type,
      subtitle: translationMaterial.details[translationIndex].subtitle,
      subtitleSegmented: translationMaterial.details[translationIndex].subtitleSegmented,
    };
    // 译文
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      projectController.deleteSubtitles({
        projectId: projectItem.id,
        body: {
          sessionId,
          monolingual: false, //true代表单语，false代表双语
          reallyDelete: false, // true代表删除，false代表清空
          audioDetail: obj,
          translationDetail: translationObj,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };
  // 加字幕类型单独的删除
  const handleAddSubtitleDelete = (sentencesItem, item, index) => {
    const originalIndex = sentenceMaterial.details.findIndex(
      (detail) => Number(detail.id) === Number(sentencesItem.originalId),
    );
    // 删除两个的原因是 加字幕是真删除，其他情况下是清空
    const deleteSubtitle = {
      ...sentenceMaterial.details[originalIndex].subtitleSegmented[index],
      type: sentenceMaterial.details[originalIndex].subtitle.type,
    };

    const translationIndex = translationMaterial.details.findIndex(
      (detail) => Number(detail.id) === Number(sentencesItem.translationId),
    );
    sentenceMaterial.details[originalIndex].subtitleSegmented = sentenceMaterial.details[
      originalIndex
    ].subtitleSegmented.filter((_, idx) => idx !== index);
    translationMaterial.details[translationIndex].subtitleSegmented = translationMaterial.details[
      translationIndex
    ].subtitleSegmented.filter((_, idx) => idx !== index);

    const originalText = sentenceMaterial.details[originalIndex].subtitleSegmented.map(
      (segmented) => segmented.text,
    );
    const combinedOriginalText = languagesArray.includes(projectDetail.language)
      ? originalText.join('')
      : originalText.join(' ');

    sentenceMaterial.details[originalIndex].subtitle.text = combinedOriginalText;

    let updateTimelineFrom = 0;
    let updateTimelineTo = 0;
    if (sentenceMaterial.details[originalIndex].subtitleSegmented.length > 0) {
      updateTimelineFrom =
        sentenceMaterial.details[originalIndex].subtitleSegmented[0].timeLineFrom;
      updateTimelineTo =
        sentenceMaterial.details[originalIndex].subtitleSegmented[
          sentenceMaterial.details[originalIndex].subtitleSegmented.length - 1
        ].timeLineTo;
    }

    sentenceMaterial.details[originalIndex].timeLineFrom = updateTimelineFrom;
    sentenceMaterial.details[originalIndex].timeLineTo = updateTimelineTo;
    sentenceMaterial.details[originalIndex].subtitle.timeLineFrom = updateTimelineFrom;
    sentenceMaterial.details[originalIndex].subtitle.timeLineTo = updateTimelineTo;

    setSentenceMaterial({ ...sentenceMaterial });
    const translationText = translationMaterial.details[translationIndex].subtitleSegmented.map(
      (segmented) => segmented.text,
    );
    const combinedTranslationText = languagesArray.includes(projectDetail.translationLanguage)
      ? translationText.join('')
      : translationText.join(' ');

    translationMaterial.details[translationIndex].subtitle.text = combinedTranslationText;

    let translationTimelineFrom = 0;
    let translationTimelineTo = 0;
    if (translationMaterial.details[translationIndex].subtitleSegmented.length > 0) {
      translationTimelineFrom =
        translationMaterial.details[translationIndex].subtitleSegmented[0].timeLineFrom;
      translationTimelineTo =
        translationMaterial.details[translationIndex].subtitleSegmented[
          translationMaterial.details[translationIndex].subtitleSegmented.length - 1
        ].timeLineTo;
    }

    translationMaterial.details[translationIndex].timeLineFrom = translationTimelineFrom;
    translationMaterial.details[translationIndex].timeLineTo = translationTimelineTo;
    translationMaterial.details[translationIndex].subtitle.timeLineFrom = translationTimelineFrom;
    translationMaterial.details[translationIndex].subtitle.timeLineTo = translationTimelineTo;

    setTranslationMaterial({ ...translationMaterial });
    const updatedSubtitleSegmented = sentenceMaterial.details[originalIndex].subtitleSegmented.map(
      (segmented) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { moreShow, ...rest } = segmented; // 去掉moreShow字段
        return rest;
      },
    );
    sentenceMaterial.details[originalIndex].subtitleSegmented = updatedSubtitleSegmented;
    const obj = {
      id: sentenceMaterial.details[originalIndex].id,
      type: 1,
      subtitle: sentenceMaterial.details[originalIndex].subtitle,
      subtitleSegmented: sentenceMaterial.details[originalIndex].subtitleSegmented,
    };

    const updatedTranslationMaterial = translationMaterial.details[
      translationIndex
    ].subtitleSegmented.map((segmented) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { moreShow, ...rest } = segmented; // 去掉moreShow字段
      return rest;
    });
    translationMaterial.details[translationIndex].subtitleSegmented = updatedTranslationMaterial;
    const translationObj = {
      id: translationMaterial.details[translationIndex].id,
      type: 4,
      subtitle: translationMaterial.details[translationIndex].subtitle,
      subtitleSegmented: translationMaterial.details[translationIndex].subtitleSegmented,
    };
    console.log(obj, translationObj);
    if (sentenceMaterial.details[originalIndex].subtitleSegmented.length <= 0) {
      sentenceMaterial.details.splice(originalIndex, 1);
    }
    if (translationMaterial.details[translationIndex].subtitleSegmented.length <= 0) {
      translationMaterial.details.splice(translationIndex, 1);
    }
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      projectController.deleteSubtitles({
        projectId: projectItem.id,
        body: {
          sessionId,
          monolingual: false, //true代表单语，false代表双语
          reallyDelete: true, // true代表删除，false代表清空
          audioDetail: obj,
          translationDetail: translationObj,
        },
      });
    } catch (error) {
      console.log(error);
    }
    console.log(deleteSubtitle, 'deleteSubtitledeleteSubtitle');

    deleteMaterial(deleteSubtitle);
  };
  // 空页面时添加
  const handleEmptyAddSubtitle = () => {
    setActiveTab('speech');
  };
  // 新增字幕
  const handleClickAddSubtitle = async (sentencesItem, item, index) => {
    console.log(sentencesItem, item, index, 's23123123123entencesItem, item, index');
    const targetIndex = sentenceMaterial.details.findIndex(
      (detail) => Number(detail.id) === Number(sentencesItem.id),
    );
    console.log(sentenceMaterial, targetIndex, 'targetIndextargetIndex');

    let body = {};
    const id = Date.now();
    // 新增时在当前句子末尾添加
    if (index + 1 >= sentencesItem.originalSegmented.length) {
      const timeLineFrom = sentenceMaterial.details[targetIndex].subtitle?.timeLineTo;
      let timeLineTo =
        targetIndex + 1 <= sentenceMaterial.details.length - 1
          ? sentenceMaterial.details[targetIndex + 1].subtitle?.timeLineFrom
          : timeLineFrom + 2000;
      if (timeLineTo - timeLineFrom > 2000) {
        timeLineTo = timeLineFrom + 2000;
      }
      const copiedObject = {
        ...sentenceMaterial.details[targetIndex],
        id,
        sentence: '',
        sentenceUrl: '',
        subtitle: {
          ...sentenceMaterial.details[targetIndex].subtitle,
          id,
          text: '',
          timeLineFrom,
          timeLineTo,
        },
        subtitleSegmented: [
          {
            id: Date.now() + id,
            text: '',
            subtitleId: id,
            timeLineFrom,
            timeLineTo,
          },
        ],
        timeLineFrom,
        timeLineTo,
        subtitleEdit: false,
        translating: false,
        from: 0,
        to: 0,
      };

      sentenceMaterial.details.splice(targetIndex + 1, 0, JSON.parse(JSON.stringify(copiedObject)));
      setSentenceMaterial({ ...sentenceMaterial });
      translationMaterial.details.splice(
        targetIndex + 1,
        0,
        JSON.parse(JSON.stringify(copiedObject)),
      );
      setTranslationMaterial({ ...translationMaterial });
      body = {
        sessionId,
        type: 3,
        audioDetail: JSON.parse(JSON.stringify(copiedObject)),
        translationDetail: JSON.parse(JSON.stringify({ ...copiedObject, type: 4 })),
      };
      console.log(copiedObject.subtitleSegmented[0], 'copiedObject.subtitleSegmented[0]');

      addSubtitleSegmented(3, JSON.parse(JSON.stringify(copiedObject.subtitleSegmented[0])));
    } else {
      const timeLineFrom =
        sentenceMaterial.details[targetIndex].subtitleSegmented[index].timeLineTo;
      let timeLineTo =
        index + 1 <= sentenceMaterial.details[targetIndex].subtitleSegmented.length - 1
          ? sentenceMaterial.details[targetIndex].subtitleSegmented[index + 1].timeLineFrom
          : sentenceMaterial.details[targetIndex].subtitleSegmented[index].timeLineTo;
      if (timeLineTo - timeLineFrom > 2000) {
        timeLineTo = timeLineFrom + 2000;
      }
      const copiedObject = {
        id: Date.now() + id,
        text: '',
        subtitleId: sentenceMaterial.details[targetIndex].id,
        timeLineFrom,
        timeLineTo,
      };
      sentenceMaterial.details[targetIndex].subtitleSegmented.splice(
        index + 1,
        0,
        JSON.parse(JSON.stringify(copiedObject)),
      );
      setSentenceMaterial({ ...sentenceMaterial });
      translationMaterial.details[targetIndex].subtitleSegmented.splice(
        index + 1,
        0,
        JSON.parse(JSON.stringify(copiedObject)),
      );
      setTranslationMaterial({ ...translationMaterial });
      body = {
        sessionId,
        type: 2,
        audioDetail: {
          type: 1,
          id: sentenceMaterial.details[targetIndex].id,
          subtitleSegmented: [JSON.parse(JSON.stringify(copiedObject))],
        },
        translationDetail: {
          type: 4,
          id: translationMaterial.details[targetIndex].id,
          subtitleSegmented: [JSON.parse(JSON.stringify(copiedObject))],
        },
      };
      addSubtitleSegmented(3, JSON.parse(JSON.stringify(copiedObject)));
    }

    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      const res = await projectController.addSubtitle({
        projectId: projectItem.id,
        body,
      });
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  };

  const handleTranslateSubtitle = (sentencesItem, errorCallback) => {
    console.log(sentencesItem, 'sentencesItem');

    const targetIndex = translationMaterial.details.findIndex(
      (detail) => Number(detail.id) === Number(sentencesItem.id),
    );
    translationMaterial.details[targetIndex].translating = true;
    sentenceMaterial.details[targetIndex].subtitleEdit = false;
    setSentenceMaterial({ ...sentenceMaterial });
    setTranslationMaterial({ ...translationMaterial });
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      projectController.timelineOp({
        projectId: projectItem.id,
        body: {
          sessionId,
          timelineOpTypeEnum: 10,
          language: translationLanguage,
          materialDetail: {
            type: 4,
          },
          text: sentencesItem.original,
          index: sentencesItem.id,
        },
      });
    } catch (error) {
      console.log(error);
      errorCallback();
      message.error('翻译失败', { id: 'translate' });
    }
  };
  const [sentencesItem, setSentencesItem] = useState({});
  const [sentencesNumber, setSentencesNumber] = useState(0);
  const [translationType, setTranslationType] = useState('');
  const translateSubtitle = (sentences, num = 1, type = 'single') => {
    setSentencesItem(sentences);
    setSentencesNumber(num);
    setSentenceTranslationPopup(true);
    setTranslationType(type);
  };
  return (
    <>
      {sentences.length > 0 && (
        <div className="subtitle_bilingual_translate_sentence">
          {sentences.map((sentencesItem, sentencesIndex) => {
            return (
              <div
                key={sentencesIndex}
                data-match-index={sentencesIndex}
                data-field="text"
                className={`sentence_item`}>
                {/* {Number(clickSubtitleItem.id) === Number(sentencesItem.id) && (
                  <div className="left_line"></div>
                )} */}
                <div className="left_line"></div>
                {sentencesItem.originalSegmented.map((item, index) => {
                  return (
                    <div key={index} className="sentence_segmented_item_box">
                      <div
                        className={`sentence_segmented_item ${timelinePlaybackTime >= item.timeLineFrom && timelinePlaybackTime < item.timeLineTo && 'sentence_segmented_item_play subtitle_active'}`}
                        onClick={() => {
                          handleSentenceItem(sentencesItem, item);
                        }}
                        onMouseLeave={() => {
                          if (sentencesItem.originalSegmented[index]) {
                            sentencesItem.originalSegmented[index].moreShow = false;
                          }
                          if (sentencesItem.translationSegmented[index]) {
                            sentencesItem.translationSegmented[index].moreShow = false;
                          }
                          sentences[sentencesIndex] = sentencesItem;
                          setSentences([...sentences]);
                        }}>
                        <div className="segmented_item_line"></div>
                        <div className="sentence_item_top">
                          <div className="sentence_item_top_time">
                            {mode === 'translation_and_tts' && (
                              <>
                                <span>
                                  {formatMilliseconds(
                                    sentencesItem.translationSegmented[index]?.timeLineFrom,
                                  )}
                                </span>
                                <span>-</span>
                                <span>
                                  {formatMilliseconds(
                                    sentencesItem.translationSegmented[index]?.timeLineTo,
                                  )}
                                </span>
                              </>
                            )}
                            {mode !== 'translation_and_tts' && (
                              <>
                                <span>{formatMilliseconds(item?.timeLineFrom)}</span>
                                <span>-</span>
                                <span>{formatMilliseconds(item?.timeLineTo)}</span>
                              </>
                            )}
                          </div>
                          {item.timeLineFrom === sentencesItem.timeLineFrom && (
                            <div
                              className={`translate_btn ${!sentencesItem?.subtitleEdit && 'translate_btn_none'} ${!sentencesItem?.translating && sentencesItem?.subtitleEdit && 'translate_btn_hover'}`}
                              onClick={() => {
                                !sentencesItem?.translating &&
                                  sentencesItem?.subtitleEdit &&
                                  translateSubtitle(sentencesItem);
                              }}>
                              <div className="text">{t('As_Edit_CreateNewTransButton')}</div>
                              {sentencesItem.translating ? (
                                <span className="loading loading-spinner loading-xs"></span>
                              ) : (
                                <img src={TransliateSubtitleIcon} alt="" />
                              )}
                            </div>
                          )}
                          <div className="sentence_item_top_operations">
                            <div className="more_box">
                              <div
                                className={`more_operations`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleMoreClick(sentencesItem, sentencesIndex, item, index);
                                }}>
                                <Icon name="icon-dot-more-horizontally" />
                              </div>
                              <div
                                className={`more_box_option btn_style ${item.moreShow && 'more_box_option_block'}`}
                                onClick={() => {
                                  mode === 'add_subtitle_and_translation' ||
                                  mode === 'add_subtitle' ||
                                  mode === 'translation'
                                    ? handleAddSubtitleDelete(sentencesItem, item, index)
                                    : handleDeleteSubtitle(sentencesItem, item, index);
                                }}>
                                {t('As_Edit_ScriptDeletion')}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="sentence_item_btm">
                          <div className="sentence_item_btm_text">
                            {sentencesItem.translating ? (
                              <div className="translating_box">{item.text}</div>
                            ) : (
                              <div
                                className={`original_meaning ${Number(clickSubtitleOriginalItem.id) === Number(item.id) && 'click_sentence_item'}`}
                                contentEditable
                                suppressContentEditableWarning
                                onPaste={handlePaste}
                                onKeyDown={handleKeyDown}
                                onBlur={(e) => {
                                  setIsInputFocused(false);
                                  const value = handleOriginalInputBlur(e, item, index);
                                  editOriginalSentence(sentencesItem, item, index, value);
                                }}
                                onInput={() => {
                                  handleOriginalInput(sentencesItem, sentencesIndex);
                                }}
                                onClick={() => {
                                  handleClickSentenceOriginalItem(item, index);
                                }}
                                onFocus={() => {
                                  setIsInputFocused(true);
                                  window.onClickGATrackEvent('subtitle-focus', {
                                    sub_type: 'original',
                                  });
                                }}
                                ref={(element) => {
                                  if (element && item.shouldFocus) {
                                    element.focus();
                                    const range = document.createRange();
                                    range.selectNodeContents(element);
                                    range.collapse(false);
                                    const selection = window.getSelection();
                                    selection.removeAllRanges();
                                    selection.addRange(range);
                                    item.shouldFocus = false;
                                  }
                                }}>
                                {item.text}
                              </div>
                            )}

                            {sentencesItem.translating ? (
                              <div className="translating_box">
                                {sentencesItem.translationSegmented[index]?.text}
                              </div>
                            ) : (
                              <div
                                className={`translation_text ${Number(clickSubtitleBilingualItem.id) === Number(item.id) && 'click_sentence_item'}`}
                                contentEditable
                                suppressContentEditableWarning
                                onPaste={handlePaste}
                                onKeyDown={handleKeyDown}
                                onBlur={(e) => {
                                  setIsInputFocused(false);
                                  const value = handleBilingualInputBlur(e, item, index);
                                  editBilingualSentence(
                                    sentencesItem,
                                    sentencesItem.translationSegmented[index],
                                    index,
                                    value,
                                  );
                                }}
                                onFocus={() => {
                                  setIsInputFocused(true);
                                  window.onClickGATrackEvent('subtitle-focus', {
                                    sub_type: 'translated',
                                  });
                                }}
                                onClick={() => {
                                  handleClickSentenceBilingualItem(item, index);
                                }}
                                ref={(element) => {
                                  if (element && item.shouldFocus) {
                                    element.focus();
                                    const range = document.createRange();
                                    range.selectNodeContents(element);
                                    range.collapse(false);
                                    const selection = window.getSelection();
                                    selection.removeAllRanges();
                                    selection.addRange(range);
                                    item.shouldFocus = false;
                                  }
                                }}>
                                {sentencesItem.translationSegmented[index]?.text}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {(mode === 'add_subtitle_and_translation' ||
                        mode === 'add_subtitle' ||
                        mode === 'translation') && (
                        <div className="add_subtitle_btn_box">
                          <div className="add_subtitle_btn">
                            <div className="line"></div>
                            <div
                              className="btn_box"
                              onClick={() => {
                                handleClickAddSubtitle(sentencesItem, item, index);
                              }}>
                              <img src={AddIcon} alt="" />
                              <div className="text">{t('As_Edit_ExportAddSubtitle334')}</div>
                            </div>
                            <div className="line"></div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      )}
      {sentences.length <= 0 &&
        (mode !== 'add_subtitle_and_translation' &&
        mode !== 'add_subtitle' &&
        mode !== 'translation' ? (
          <div className="subtitle_empty_box">
            <div className="text">
              {/* Now without any subtitles, you can generate subtitles by add speech. */}
              {t('As_Edit_NoSubConfirm')}&nbsp;{t('As_Edit_GenerateSub')}
            </div>
            <div className="empty_sentence_display">
              <button className="btn btn-primary btn-sm" onClick={handleEmptyAddSubtitle}>
                <Icon name="icon-add-stroke" />
                <span>{t('As_Edit_CreateSpeech')}</span>
              </button>
            </div>
          </div>
        ) : (
          <div className="addsubtitle_empty_box">
            <img src={AddsubtitleEmptySvg} alt="" />
            <div className="text">{t('As_Edit_Subexportchoice1')}</div>
          </div>
        ))}
      <EditPopUp
        sentenceNum={sentencesNumber}
        onSentenceTranslate={(errorCallback) =>
          handleTranslateSubtitle(sentencesItem, errorCallback)
        }
        handleUpdateAll={(errorCallback) => {
          handleUpdateAll(errorCallback);
        }}
        translationType={translationType}
      />
    </>
  );
}
